import { LoginForm } from '@on3/ui-lib/components/Auth/Forms/Login';
import { RegisterForm } from '@on3/ui-lib/components/Auth/Forms/Register';
import { useAuth } from '@on3/ui-lib/index';
import { useEffect, useState } from 'react';

import styles from './AuthForm.module.scss';

export type AuthViewType = 'authenticated' | 'login' | 'register';

interface AuthFormProps {
  showHeader?: boolean;
  defaultView?: AuthViewType;
  onSwitch?: (view: AuthViewType) => void;
  callback?: (props?: any) => void;
}

export interface FormProps {
  showHeader?: boolean;
  callback?: (props?: any) => void;
  switchForm?: (view: AuthViewType) => void;
}

export const AuthForm = ({
  showHeader = true,
  defaultView = 'register',
  onSwitch,
  callback,
}: AuthFormProps) => {
  const { user } = useAuth();
  const [active, setActive] = useState<AuthViewType>(defaultView);

  const handleSwitch = (view: AuthViewType) => {
    setActive(view);
    onSwitch?.(view);
  };

  useEffect(() => {
    if (user?.uid) {
      onSwitch?.('authenticated');
    }
  }, [onSwitch, user]);

  if (user?.uid) {
    return (
      <div className={styles.block} data-ui="auth-logged-in">
        <p>
          You&apos;re logged in as <strong>{user.e}</strong>.
        </p>
      </div>
    );
  }

  const props: FormProps = { showHeader, callback, switchForm: handleSwitch };

  return (
    <div className={styles.block} data-ui="auth-form">
      {active === 'login' && <LoginForm {...props} />}
      {active === 'register' && <RegisterForm {...props} />}
    </div>
  );
};
